// What switching each per-project setting on costs, worded once for the project's
// Settings tab and the team's (docs/Y2026-Q4/design-switch-on-cost-warnings.md). The
// figures come from the backend, already rounded to $5.
import type { SwitchCosts } from "../api/hooks/useAgentPortfolio";

/** One figure, or across a card's projects a range whose figures sit beside each. */
export const usdRange = (costs: number[]): string => {
  const low = Math.min(...costs);
  const high = Math.max(...costs);
  return low === high ? `~$${low}` : `~$${low}-${high} (shown beside each)`;
};

/** ``firstRun`` is one figure ("~$15") or, across a card's projects, a range. */
export const specialistWarning = (costs: SwitchCosts, firstRun: string): string =>
  `Per-project cost: first run ${firstRun}, then $${costs.specialist_daily_low}-` +
  `${costs.specialist_daily_high}/day on every future day where there is activity on ` +
  "the project.";

/** ``firstRun`` covers every specialist that would then work the project. */
export const scheduledRunsWarning = (costs: SwitchCosts, firstRun: string): string =>
  `Per-project cost: first run ${firstRun}, then $${costs.specialist_daily_low}-` +
  `${costs.specialist_daily_high}/day per specialist on every future day where there is ` +
  "activity on the project.";

export const reviewerWarning = (costs: SwitchCosts): string =>
  `Per-project cost: ~$${costs.automated_review_nightly}/day on every day the nightly ` +
  "run works the project.";

const assessCost = (costs: SwitchCosts): string =>
  `Per-project cost: ~$${costs.clause_first_assess} to assess on its first run, then ` +
  `under $${costs.clause_assess_daily_max}/day on days with activity on the project.`;

export const clientSpecWarning = (costs: SwitchCosts): string =>
  `Clause extraction: ~$${costs.client_spec_extract} once per client specification, ` +
  `shared by every site it binds. ${assessCost(costs)}`;

export const masterAgreementWarning = (costs: SwitchCosts): string =>
  `Clause extraction: ~$${costs.master_agreement_extract} once per master agreement, ` +
  `shared by every site signed under it. ${assessCost(costs)}`;

export const sppaWarning = (costs: SwitchCosts): string =>
  `Clause extraction: ~$${costs.sppa_extract} per project, once per signed SPPA ` +
  `version. ${assessCost(costs)}`;
